// extracted by mini-css-extract-plugin
export default {"cls1":"Link-cls1___199c7ed58610ac0f824","cls2":"Link-cls2__ed5c95ed59e778671e1a Link-cls1___199c7ed58610ac0f824"};